<div
    class="Cell"
    [ngClass]="{ 'team-dd': !isMobile, 'team-dd-mob': isMobile }"
    [ngStyle]="{
        'color': game.game_context.TeamBingo.current_team != null ? 'white' : '',
        'background-color': game.game_context.TeamBingo.current_team != null ? teamColors[game.game_context.TeamBingo.current_team] : '',
    }">
    <div class="teamList team-dd" (click)="selectTeam()">
        <span class="teamName" *ngIf="game.game_context.TeamBingo.current_team == null">{{ content.FriendsSelectTeam }} </span>
        <span class="teamName" *ngIf="game.game_context.TeamBingo.current_team != null">{{
            game.game_context.TeamBingo.current_team | lowercase
        }}</span>
        <span class="teamddArrow theme-arrow-down"></span>
    </div>
</div>
<!-- <div *ngIf="selectTeamModal && !isPurchased" class="teamSelectModal-overlay"></div>
<div *ngIf="selectTeamModal && !isPurchased" class="teamSelectModal">
    <div class="syt">{{content.FriendsSelectYourTeam}} <i class="theme-arrow-down" (click)="onTeamSelected('')"></i>
    </div>
    <ul class="team-select-list">
        <li *ngFor="let team of currentGame.game_context.TeamBingo.teams" (click)="onTeamSelected(team)"
            [ngStyle]="{ 'color': currentGame.game_context.TeamBingo.current_team == team? 'white':teamColors[team],'background-color': currentGame.game_context.TeamBingo.current_team == team? teamColors[team]:'' }">
            {{team| lowercase}}</li>
    </ul>
</div> -->
